
import { defineComponent } from 'vue';
import { Button } from '../atoms';
import { ModalAttack } from '@/components/molecules';

export default defineComponent({
  name: 'PokemonDetails',
  components: {
    Button,
    ModalAttack,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modal: false,
      attack: [],
    };
  },
  methods: {
    handleModal() {
      this.modal = !this.modal;
    },
    modalAttack(attack: []) {
      this.handleModal();
      this.attack = attack;
    },
  },
});
